<template>
  <el-tabs tab-position="left">
    <el-tab-pane label="内网设置">
      <inner-net-setting></inner-net-setting>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import InnerNetSetting from './innerNetSetting.vue';
export default {
  components: {
    InnerNetSetting
  }
}
</script>

